import React from 'react';

export default function StatisticsLoader() {
  return (
    <div className="flex w-full justify-center">
      <span className="font-semibold text-neutral-600 animate-pulse">Loading...</span>
    </div>
  );
}
